import React from "react";
import { useParams } from "react-router-dom";
import { Container, Row, Col, Card } from "react-bootstrap";
import "./Product.css";
import Footer from "../../../components/footer/Footer";
import Banner from "../../../components/banner/banner";
import products_banner_img from "../../../assets/images/products_banner_img.png";
import ListCardNew from "../../../components/list-card-new/ListCardNew";

const Product = ({ productCards }) => {
  const { slug } = useParams();
  const products = [
    {
      id: 1,
      slug:"non-custodial-wallet-management",
      title: "Non-Custodial Wallet Management",
      subtitle:
        "A secure, user-friendly non-custodial wallet solution for managing digital assets across multiple blockchain networks.",
      image: "https://via.placeholder.com/500x500",
      overview:
        "Paytez is a comprehensive non-custodial wallet platform that allows users to securely manage their digital assets without giving up control of their private keys. The platform supports multiple blockchain networks and provides a seamless user experience.",
      features: [
        "Non-custodial security model",
        "Multi-chain support",
        "User-friendly interface",
        "Advanced security features",
        "Developed Before ChatGPT Era",
      ],
      achievements: [
        "Made web3 adoptions simple",
        "Zero security incidents",
        "Multi-chain integration completed",
      ],
      techStack: ["Solidity", "MERN Stack", "Web3js"],
    },

    {
      id: 2,
      slug:"trade-finance-with-esg-score",
      title: "Trade Finance with ESG Score",
      subtitle:
        "A blockchain-based trade finance platform that incorporates ESG scoring for sustainable trade practices.",
      image: "https://via.placeholder.com/500x500",
      overview:
        "An innovative trade finance platform that combines traditional trade finance with ESG (Environmental, Social, and Governance) scoring. The platform enables sustainable trade practices while providing transparent and efficient financing solutions.",
      features: [
        "ESG scoring integration",
        "Automated trade processes",
        "Transparent transaction records",
        "Sustainable trade incentives",
        "Developed Before ChatGPT Era",
      ],
      achievements: [
        "Integrated TradeTrust",
        "Integrated ESG scoring",
        "Reduced processing time by 60%",
        "Improved sustainability metrics",
      ],
      techStack: ["Go", "Solidity", "XDC Network"],
    },

    {
      id: 3,
      slug:"synthetic-derivative-protocol-rwa-tokenization",
      title: "Synthetic Derivative Protocol - RWA Tokenization",
      subtitle:
        "A comprehensive Real World Asset (RWA) tokenization platform enabling fractional ownership of physical assets.",
      image: "https://via.placeholder.com/500x500",
      overview:
        "Synthetic Dervicative Protocol is a revolutionary RWA tokenization platform that enables fractional ownership of real-world assets through blockchain technology. The platform provides secure, transparent, and efficient tokenization of various asset classes.",
      features: [
        "Multi-asset tokenization support",
        "Fractional ownership capabilities",
        "Regulatory compliance framework",
        "Liquidity provision mechanisms",
        "Before ChatGPT Era",
      ],
      achievements: [
        "Tokenized $500M+ in real-world assets",
        "Solid smart contract development to handle complex financial instruments",
        "High liquidity and trading volume",
        "Deployed in Testnets",
      ],
      techStack: ["Solidity", "MERN Stack", "Web3js"],
    },
    {
      id: 4,
      slug:"blockchain-as-a-service-platform",
      title: "Blockchain as a Service Platform",
      subtitle:
        "A comprehensive BaaS platform providing enterprise-grade blockchain infrastructure and services.",
      image: "https://via.placeholder.com/500x500",
      overview:
        "Blockyt is a comprehensive Blockchain-as-a-Service platform that provides enterprise-grade blockchain infrastructure. The platform enables businesses to easily deploy, manage, and scale blockchain networks with high reliability and security.",
      features: [
        "One-click blockchain deployment",
        "Enterprise-grade security",
        "Auto-scaling capabilities",
        "Multi-cloud support",
      ],
      achievements: [
        "Built for enterprise use cases",
        "99.99% uptime SLA",
        "Reduced deployment time by 90%",
        "Cost savings of 70% for clients",
      ],
      techStack: [
        "Hyperledger Fabric",
        "Go",
        "MERN Stack",
        "Docker",
        "Docker Swarm",
      ],
    },
    {
      id: 5,
      slug:"business-automation-agentic-ai",
      title: "Business Automation with Agentic AI",
      subtitle:
        "An intelligent business automation platform powered by Agentic AI for the water purification industry.",
      image: "https://via.placeholder.com/500x500",
      overview:
        "Seigai is an advanced business automation platform that leverages Agentic AI to automate complex workflows in the water purification industry. The system autonomously handles customer inquiries, processes orders, manages inventory, and provides real-time communication across multiple channels.",
      features: [
        "Autonomous business process automation",
        "Multi-channel communication (Telegram, WhatsApp)",
        "Intelligent inventory management",
        "Real-time customer support",
      ],
      achievements: [
        "Automated 80% of business processes",
        "Reduced response time by 90%",
        "Increased customer satisfaction by 40%",
      ],
      techStack: [
        "LangGraph",
        "Python",
        "FastAPI",
        "LLM",
        "OpenAI API",
        "Telegram SDK",
        "WhatsApp SDK",
        "WebSocket",
      ],
    },
    {
      id: 6,
      slug:"frognosis-data-intelligence-dashboard",
      title: "Frognosis - Data Intelligence Dashboard",
      subtitle:
        "An intelligent data analytics platform providing real-time insights and predictive analytics for business intelligence.",
      image: "https://via.placeholder.com/500x500",
      overview:
        "Frognosis is an advanced data intelligence platform that provides real-time analytics, predictive insights, and business intelligence. The platform uses AI to analyze data and provide actionable insights for decision-making.",
      features: [
        "Real-time data analytics",
        "Predictive modeling",
        "Interactive dashboards",
        "AI-powered insights",
      ],
      achievements: [
        "Improved decision accuracy by 85%",
        "Text to SQL Generation",
        "Reduced analysis time by 70%",
        "Generated various insights using charts and graphs",
      ],
      techStack: [
        "Fastify",
        "MEAN Stack",
        "Redis",
        "OpenAI",
        "Socket",
        "Chart.js",
        "three.js",
        "Langgraph",
      ],
     },
    {
      id: 7,
      slug:"blockchain-network-layer-1-blockchain",
      title: "Blockchain Network - Layer 1 Blockchain",
      subtitle:
        "A custom end-to-end blockchain network with explorer, RPC server, and monitoring capabilities.",
      image: "https://via.placeholder.com/500x500",
      overview:
        "A comprehensive Layer 1 blockchain network with complete infrastructure including blockchain explorer, RPC server, master nodes, POS algorithm, and monitoring systems. The network provides high performance and security.",
      features: [
        "Custom blockchain implementation",
        "Blockchain explorer with frontend/backend",
        "RPC server for API access",
        "Master nodes and sync cluster",
        "POS consensus algorithm",
        "Node health monitoring",
        "Faucet for test tokens",
      ],
      achievements: [
        "Sub-second transaction finality",
        "Zero security incidents",
      ],
      techStack: [
        "GoLang",
        "Solidity",
        "Bash Script",
        "Docker",
        "NodeJS",
        "NextJS",
        "MongoDB",
        "Ubuntu OS",
        "Python",
      ],
    },
    {
      id: 8,
      slug:"business-automation-agentic-ai-logistics",
      title: "Business Automation with Agentic AI for Logistics",
      subtitle:
        "An intelligent logistics automation platform using Agentic AI to optimize supply chain operations.",
      image: "https://via.placeholder.com/500x500",
      overview:
        "TurnR is an advanced logistics automation platform that uses Agentic AI to optimize supply chain operations. The system can autonomously manage inventory, route optimization, and customer communication.",
      features: [
        "Autonomous logistics optimization",
        "Real-time route planning",
        "Intelligent inventory management",
        "Automated customer communication",
      ],
      achievements: [
        "Reduced delivery time by 40%",
        "Optimized shipments",
        "Improved customer satisfaction by 60%",
      ],
      techStack: [
        "Langgraph",
        "Python",
        "FastAPI",
        "LLM",
        "OpenAI",
        "Twilio",
        "ReactJS",
        "NodeJS",
        "Websocket",
      ],
    },
    {
      id: 9,
      slug:"agentic-ai-for-logistics",
      title: "Agentic AI As a Service",
      subtitle:
        "A comprehensive AI-as-a-Service platform providing Agentic AI capabilities for businesses across various industries.",
      image: "https://via.placeholder.com/500x500",
      overview:
        "TalkLeap is a comprehensive AI-as-a-Service platform that provides Agentic AI capabilities for businesses. The platform offers pre-built AI agents, custom agent development, and integration services.",
      features: [
        "Pre-built AI agents for common use cases",
        "Custom agent development",
        "Multi-channel integration",
        "Real-time agent monitoring",
      ],
      achievements: ["10+ AI agents deployed", "5+ enterprise clients"],
      techStack: ["Langgraph", "Python", "FastAPI", "LLM", "OpenAI"],
    },
    {
      id: 10,
      slug:"pangents-agentic-ai-for-logistics",
      title: "Pangents - Agentic AI for Logistics",
      subtitle:
        "A comprehensive agents marketplace platform providing Agentic AI capabilities for logistics services.",
      image: "https://via.placeholder.com/500x500",
      overview:
        "Pangents is a comprehensive Agentic AI platform that provides Agentic AI capabilities for Logistics. The platform offers pre-built AI agents, custom agent development, and integration services.",
      features: [
        "Pre-built AI agents for Logistics use cases",
        "Custom agent development",
        "Multi-channel integration",
        "Real-time agent monitoring",
      ],
      achievements: [
        "10+ AI agents deployed for Logistics",
        "5+ enterprise clients",
        "Voice AI Integration",
        "Real-time agent monitoring",
      ],
      techStack: [
        "Langgraph",
        "Python",
        "FastAPI",
        "LLM",
        "OpenAI",
        "ReactJS",
        "NodeJS",
        "Websocket",
        "Elevenlabs",
        "Voice AI",
      ],
    },
    {
      id: 11,
      slug:"the-guiding-mind-complete-entrepreneurial-platform",
      title: "The Guiding Mind | Complete Entrepreneurial Platform",
      subtitle:
        "From idea validation to investor-ready pitch decks. Hadi guides entrepreneurs through every step with AI-powered insights, expert advice, and personalized recommendations.",
      image: "https://via.placeholder.com/500x500",
      overview:
        "From idea validation to investor-ready pitch decks. Hadi guides entrepreneurs through every step with AI-powered insights, expert advice, and personalized recommendations. Hadi is an AI-powered platform that helps teams create stunning pitch decks and presentations collaboratively.",
      features: [
        "Idea to Investment Ready Pitch Deck",
        "Idea Validation",
        "Guided Pitch Deck Creation",
        "Expert Advice",
        "Personalized Recommendations",
      ],
      achievements: [
        "Canva like Pitch Deck Creation",
        "Collaborative Pitch Deck Creation",
        "Idea vetting from passion to validation",
        "Real-time agent monitoring",
      ],
      techStack: [
        "Langgraph",
        "Python",
        "FastAPI",
        "LLM",
        "OpenAI",
        "ReactJS",
        "NodeJS",
        "Websocket",
        "Elevenlabs",
        "Voice AI",
      ],
    },
    {
      id: 12,
      slug:"decentralized-oracle-network",
      title: "Decentralized Oracle Network",
      subtitle:
        "A comprehensive decentralized oracle solution built to provide real-time data feeds for smart contracts.",
      image: "https://via.placeholder.com/500x500",
      overview:
        "A robust decentralized oracle network that provides secure, reliable, and tamper-proof data feeds to smart contracts on the XDC Network. The system ensures data integrity and availability through a network of independent node operators.",
      features: [
        "Real-time data feeds for smart contracts",
        "Decentralized node network",
        "Secure data validation mechanisms",
        "High availability and reliability",
        "Developed Before ChatGPT Era",
      ],
      achievements: [
        "Successfully deployed on XDC Network mainnet",
        "Achieved 99.9% uptime",
        "Integrated with 100+ smart contracts",
      ],
      techStack: ["Go Language", "Solidity", "Evm Compatible Network"],
    },
    {
      id: 13,
      slug:"vaccine-tracking-solution-for-costa-rica",
      title: "Vaccine Tracking Solution for Costa Rica",
      subtitle:
        "A blockchain-based vaccine tracking system ensuring transparency and traceability in the vaccine supply chain, during covid-19 times.",
      image: "https://via.placeholder.com/500x500",
      overview:
        "A comprehensive vaccine tracking solution built on Hyperledger Fabric that provides end-to-end traceability of vaccines from manufacturing to administration. The system ensures vaccine authenticity and prevents counterfeiting.",
      features: [
        "End-to-end vaccine traceability",
        "Anti-counterfeiting measures",
        "Real-time tracking capabilities",
        "Regulatory compliance features",
        "Developed Before ChatGPT Era",
      ],
      achievements: [
        "Successfully deployed in Costa Rica",
        "Zero counterfeit incidents",
        "Improved supply chain transparency",
      ],
      techStack: ["Hyperledger Fabric", "Go", "MERN Stack"],
    },
    {
      id: 14,
      slug:"rapidflow-finance",
      title: "RapidFlow Finance",
      subtitle:
        "A decentralized finance (DeFi) platform offering lending, borrowing, and yield farming services.",
      image: "https://via.placeholder.com/500x500",
      overview:
        "RapidFlow Finance is a comprehensive DeFi platform that provides lending, borrowing, and yield farming services. The platform offers competitive interest rates and innovative financial products.",
      features: [
        "Decentralized lending and borrowing",
        "Yield farming opportunities",
        "Liquidity provision rewards",
        "Cross-chain compatibility",
      ],
      achievements: [
        "Solid Smart Contract Development",
        "0.1% default rate",
        "Cross-chain integration completed",
      ],
      techStack: ["Ethereum", "Solidity", "MERN Stack", "Web3js"],
    },
    {
      id: 15,
      slug:"crypto-bridge",
      title: "Crypto Bridge",
      subtitle:
        "A cross-chain bridge enabling seamless asset transfers between Ethereum, Polygon, and XDC networks.",
      image: "https://via.placeholder.com/500x500",
      overview:
        "PayPlic is a secure cross-chain bridge that enables seamless asset transfers between multiple blockchain networks. The platform ensures fast, secure, and cost-effective cross-chain transactions.",
      features: [
        "Multi-chain support",
        "Fast cross-chain transfers",
        "Low transaction fees",
        "Secure bridge protocols",
      ],
      achievements: [
        "Processed cross-chain transfers",
        "Zero security incidents",
        "Support for 5+ tokens",
      ],
      techStack: ["Ethereum", "Polygon", "XDC Network", "Solidity", "Web3js"],
    },
    {
      id: 16,
      slug:"real-world-asset-tokenization",
      title: "Real World Asset Tokenization",
      subtitle:
        "A comprehensive platform for tokenizing real-world assets on the Ethereum network.",
      image: "https://via.placeholder.com/500x500",
      overview:
        "A comprehensive RWA tokenization platform that enables fractional ownership of real-world assets through Ethereum-based tokens. The platform provides secure, transparent, and efficient asset tokenization.",
      features: [
        "Multi-asset tokenization",
        "Fractional ownership",
        "Regulatory compliance",
        "Liquidity mechanisms",
      ],
      achievements: [
        "Tokenized Real Estate Assets",
        "Regulatory compliance achieved",
        "KYC/AML Compliance Integration",
        "High trading volume",
      ],
      techStack: ["Solidity", "Ethereum Network", "MERN Stack"],
    },
    {
      id: 17,
      slug:"nft-marketplace-rarible-like",
      title: "NFT Marketplace (Rarible-like)",
      subtitle:
        "A comprehensive NFT marketplace supporting creation, trading, and management of non-fungible tokens.",
      image: "https://via.placeholder.com/500x500",
      overview:
        "A comprehensive NFT marketplace that enables users to create, buy, sell, and trade non-fungible tokens. The platform supports multiple blockchain networks and provides a seamless user experience.",
      features: [
        "Multi-chain NFT support",
        "Creator tools and royalties",
        "Advanced search and filtering",
        "Secure wallet integration",
      ],
      achievements: [
        "Solid Smart Contract Development",
        "Zero security incidents",
      ],
      techStack: ["Solidity", "Ethereum", "Polygon", "Web3JS", "MERN Stack"],
    },
    {
      id: 18,
      slug:"data-standardization-governance",
      title: "Data Standardization & Governance",
      subtitle:
        "A comprehensive data governance platform ensuring data quality, consistency, and compliance across organizations.",
      image: "https://via.placeholder.com/500x500",
      overview:
        "A comprehensive data governance platform that ensures data quality, consistency, and compliance across organizations. The platform provides automated data validation, standardization, and governance capabilities.",
      features: [
        "Automated data validation",
        "Data quality monitoring",
        "Compliance reporting",
        "Data lineage tracking",
      ],
      achievements: [
        "Processed 1TB+ of data daily",
        "Golden Record Management",
        "De-duplication of data",
        "Zero data quality incidents",
      ],
      techStack: ["Python", "Apache Spark", "Kylin", "MERN Stack"],
    },
    {
      id: 19,
      slug:"lending-borrowing-protocol",
      title: "Lending & Borrowing Protocol",

      subtitle:
        "A decentralized lending and borrowing protocol built on XDC Network providing secure and efficient financial services.",
      image: "https://via.placeholder.com/500x500",
      overview:
        "A comprehensive lending and borrowing protocol that enables users to lend and borrow digital assets securely and efficiently. The protocol provides competitive interest rates and innovative financial products.",
      features: [
        "Decentralized lending/borrowing",
        "Automated interest calculations",
        "Liquidation mechanisms",
        "Governance token integration",
      ],
      achievements: [
        "$3M+ total value locked",
        "500+ active users",
        "0.05% default rate",
        "Cross-chain compatibility",
      ],
      techStack: ["Solidity", "Web3js", "XDC Network", "MERN Stack"],
    },
  ];

  // const createSlug = (title) =>
  //   title.toLowerCase().replace(/\s+/g, "-").replace(/[^\w-]+/g, "");

  const product = products.find((p) => p.slug === slug);
  if (!product) {
    return (
      <div style={{ padding: "120px 20px" }}>
        <h2>Product Not Found</h2>
      </div>
    );
  }

  return (
    <section className="product_page">
      <Container className="product_page_container mt-5">
        {/* Title & Tech Stack */}
        <Row className="align-items-center main_container">
          <Col lg={6} md={12}>
            <h1 className="product_title">{product.title}</h1>
            <p className="product_subtitle">{product.subtitle}</p>

            <div className="tech_stack center_tech_stack">
              {product.techStack.map((tech, index) => (
                <span key={index}>{tech}</span>
              ))}
            </div>
          </Col>

          <Col lg={6} md={12} className="product_image_col">
            <div className="product_image_wrapper">
              <img
                src={products_banner_img}
                alt={product.title}
                className="product_image"
              />
            </div>
          </Col>
        </Row>

        {/* Overview */}
        <div className="product_card mt-4">
          <h4>Overview</h4>
          <p>{product.overview}</p>
        </div>

        {/* Features & Achievements using ListCard */}
        <Row className="mt-4">
          <Col md={4} className="mb-4">
            <ListCardNew
              title="Key Features"
              list={product.features}
            />
          </Col>

          <Col md={4} className="mb-4">
            <ListCardNew
              title="Achievements & Impact"
              list={product.achievements}
            />
          </Col>

          {/* Optional third card */}
          {/* <Col md={4} className="mb-4">
            <ListCard
              title="Legacy / Developed Before ChatGPT Era"
              list={product.legacyFeatures}
            />
          </Col> */}
        </Row>
      </Container>

      <Footer />
    </section>
  );
};

export default Product;
